import { paths } from '@primum/api-types';
import { fetchClient } from '@/util/fetchClient';

type RelayMessageV2Params =
  paths['/v2/inquiries/{conversationId}/messages/{messageSid}/relay']['post']['parameters']['path'] &
    paths['/v2/inquiries/{conversationId}/messages/{messageSid}/relay']['post']['requestBody']['content']['application/json'];

export type RelayedMessageV2 =
  paths['/v2/inquiries/{conversationId}/messages/{messageSid}/relay']['post']['responses'][200]['content']['application/json']['data'];

export async function relayMessageV2({
  conversationId,
  messageSid,
  targetConversationId,
}: RelayMessageV2Params): Promise<RelayedMessageV2> {
  const { data } = await fetchClient.POST(
    '/v2/inquiries/{conversationId}/messages/{messageSid}/relay',
    {
      params: { path: { conversationId, messageSid } },
      body: { targetConversationId },
    }
  );

  if (!data?.data) {
    throw new Error('Unable to relay message');
  }

  return data.data;
}
